import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as StudentIcon } from './student.svg';

export const Student = IconHOC(StudentIcon);
